import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const messages = [
  'Gathering data...',
  'Evaluating results...',
  'Crunching numbers...',
  'Almost there...',
  'Just a moment more...',
];

interface LoadingFeedbackProps {
  size?: 'big' | 'small';
}

export const LoadingFeedback = ({
  size = 'big',
}: LoadingFeedbackProps): React.JSX.Element => {
  const [ index, setIndex ] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % messages.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const isBig = size === 'big';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: isBig ? '100%' : '200px',
        justifyContent: 'center',
        alignItems: 'center',
        transform: isBig ? 'scale(1)' : 'scale(0.5)',
        transformOrigin: 'center',
        margin: 'auto',
      }}
    >
      <Reordering />
      <div className='w-12 h-12 mb-4 border-4 border-blue-400 border-t-transparent rounded-full animate-spin' />

      <AnimatePresence mode='wait'>
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
          className='text-white text-2xl font-bold'
        >
          {messages[index]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export const Reordering = (): React.JSX.Element => {
  const [ order, setOrder ] = useState(initialOrder);

  useEffect(() => {
    const timeout = setTimeout(() => setOrder(shuffle(order)), 1000);
    return () => clearTimeout(timeout);
  }, [ order ]);

  return (
    <ul style={container}>
      {order.map((backgroundColor) => (
        <motion.li
          key={backgroundColor}
          layout
          transition={spring}
          style={{ ...item, backgroundColor: backgroundColor }}
        />
      ))}
    </ul>
  );
};

const initialOrder = [ '#4268ED', '#4895EF', '#4CC9F0', '#FFF' ];

const shuffle = ([ ...array ]: string[]) => {
  return array.sort(() => Math.random() - 0.5);
};

const spring = {
  type: 'spring',
  damping: 20,
  stiffness: 300,
};

const container: React.CSSProperties = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
  width: 300,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
};

const item: React.CSSProperties = {
  width: 100,
  height: 100,
  borderRadius: '10px',
};
